import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        margin: "10px"
    },
    formControl: {
        minWidth: "60%",
        margin: "10px",
    },
    input: {
        padding: "5px",
    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "top"
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    paddingPaper: {
        paddingBottom: theme.spacing(2),
        minHeight: "100%",
        height: "100%"
    },
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        marginTop: "10px",
    },
    datePicker: {
        minWidth: "100%",
        marginTop: theme.spacing(2),
    },

    buttonZeitraum: {
        "&.Mui-selected": {
            backgroundColor: theme.palette.secondary.main + "!important",
            color: "black" + "!important",
            borderColor: theme.palette.secondary.main + "!important"
        }
    },

    disabledColor: {
        "&.Mui-disabled": {
            backgroundColor: theme.palette.grey[200] + "!important",
            color: "black" + "!important",
            borderColor: theme.palette.grey[400] + "!important"
        }
    },

    textFieldBorder: {
        borderColor: theme.palette.grey[200] + "!important",
        "& .MuiOutlinedInput-root": {
            borderColor: theme.palette.grey[200] + "!important",
            "&:active": {
                borderColor: theme.palette.grey[200] + "!important",
            },
            "&:hover": {
                borderColor: theme.palette.grey[200] + "!important",
            },
        },
        "& .MuiTextField-root": {
            borderColor: theme.palette.grey[200] + "!important",
            "&:active": {
                borderColor: theme.palette.grey[200] + "!important",
            },
            "&:hover": {
                borderColor: theme.palette.grey[200] + "!important",
            },
        }
    },

    marks: {
        fontSize: "large",
        markLabel: {
            fontSize: "60px"
        },
        "& .MuiSlider-markLabel": {
            fontSize: "1.2rem"
        },
    },

    gridStyle: {
        border: 1,
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: theme.palette.grey[50],
        },
        '& .super-app-theme--cell': {
            backgroundColor: theme.palette.grey[50],
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
            borderRight: `1px solid ${'#f0f0f0'}`,
        },
        '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
            borderBottom: `1px solid ${'#f0f0f0'}`,
        },
        '& .pos': {
            backgroundColor: '#99cc99',
            color: '#1a3e72',
        },
        '& .neg': {
            backgroundColor: '#ffd27f',
            color: '#1a3e72',
        },
        '& .neu': {
            backgroundColor: '#e39999',
            color: '#1a3e72',
        },

    },

    table: {
        borderCollapse: "separate",
    },

    tableCellStyle: {
        borderRight: `1px solid ${'#ffffff'}`,
        borderBottom: `1px solid ${'#ffffff'}`

    },
    tableCellKursivStyle: {
        borderRight: `1px solid ${'#ffffff'}`,
        borderBottom: `1px solid ${'#ffffff'}`,
        fontStyle: 'italic',
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.grey[200]


    },

    tableHeaderHorizontalLeftmost: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: '#ffffff',
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 999,
    },
    tableHeaderHorizontal: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: '#ffffff',
        position: 'sticky',
        top: 0,
        zIndex: 99
    },
    tableHeaderHorizontalClickable: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        position: 'sticky',
        top: 0,
        zIndex: 99,
        backgroundColor: '#ffffff',
        "& .MuiTableCell-root": {
            "&:hover": {
                backgroundColor: theme.palette.grey[200] + "!important",
            },
        },
        "&:hover": {
            backgroundColor: theme.palette.grey[200] + "!important",
        },
    },
    tableHeaderHorizontalBlank: {
        borderBottom: `1px solid ${'#ffffff'}`,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        position: 'sticky',
        top: 0,
        zIndex: 99
    },
    tableHeaderVertical: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: '#ffffff',
        position: 'sticky',
        left: 0,
        zIndex: 99,
    },
    tableHeaderVerticalClickable: {
        //borderCollapse: "separate",
        position: "sticky",
        left: 0,
        zIndex: 99,
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${theme.palette.grey[200]}` + "!important",
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        //boxShadow: `0 -1px #ccc ,  0 1px #ccc`,
        "& .MuiTableCell-root": {
            "&:hover": {
                backgroundColor: theme.palette.grey[200] + "!important",
            },
            "&:after": {
                position: "absolute",
                bottom: 0,
                left: 0,
                backgroundColor: theme.palette.grey[200] + "!important",
            },
        },
        "&:hover": {
            backgroundColor: theme.palette.grey[200] + "!important",
        },
        "&:after": {
            //position: "absolute",
            //bottom: 0,
            //left: 0,
            backgroundColor: theme.palette.grey[200] + "!important",
        },
    },

    tableCellHeaderStyle: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        //position: "sticky",
        //left: 0,
        //top: 0,
        //zIndex: 999,
        backgroundColor: '#ffffff',
    },

    tableCellHeaderStyleVertical: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        //position: "sticky",
        //top: 0,
        //zIndex: 99,
        backgroundColor: '#ffffff',
        //writingMode: "vertical-lr",
        //transform: `translate(0%, 0%) rotate(180deg)`,
    },
    tableCellBlank: {
        borderBottom: `1px solid ${'#ffffff'}`,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
    },
    tableCellUw: {
        //borderCollapse: "separate",
        //position: "sticky",
        //left: 0,
        //zIndex: 99,
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${theme.palette.grey[200]}` + "!important",
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        //boxShadow: `0 -1px #ccc ,  0 1px #ccc`,
        "& .MuiTableCell-root": {
            "&:hover": {
                backgroundColor: theme.palette.grey[200] + "!important",
            },
            "&:after": {
                position: "absolute",
                bottom: 0,
                left: 0,
                backgroundColor: theme.palette.grey[200] + "!important",
            },
        },
        "&:hover": {
            backgroundColor: theme.palette.grey[200] + "!important",
        },
        "&:after": {
            //position: "absolute",
            //bottom: 0,
            //left: 0,
            backgroundColor: theme.palette.grey[200] + "!important",
        },
    },
    tableCellKenngroesseHeader: {
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        "& .MuiTableCell-root": {
            "&:hover": {
                backgroundColor: theme.palette.grey[200] + "!important",
            },
        },
        "&:hover": {
            backgroundColor: theme.palette.grey[200] + "!important",
        },
    }

}), { index: 1 });